import React, { Component } from 'react';

import ReactPaginate from 'react-paginate';

import OrderEditHeader from './OrderEditHeader';
import OrderItemList from './OrderItemList';


export default class OrderEdit extends Component {
  render() {
    const {
      order,
      deliveryDate,
      searchQuery,
      station,
      stationOptions,
      onSearchQueryChanged,
      onStationChanged,
      handleOrderSubmit,
      handleDeliveryDateChange,

      itemList,
      itemAmounts,
      itemPresentations,
      itemGrades,
      itemListPage,
      handleListItemValueChange,
      handleAddItem,
      errors,

      isUpdating,
      handleOrderItemValueChange,
      handleDeleteItem,

      grades,
    } = this.props;
    return (
    <div>
      <OrderEditHeader
        order={order}
        deliveryDate={deliveryDate}
        searchQuery={searchQuery}
        station={station}
        stationOptions={stationOptions}
        onStationChanged={onStationChanged}
        onSearchQueryChanged={onSearchQueryChanged}
        handleOrderSubmit={handleOrderSubmit}
        handleDeliveryDateChange={handleDeliveryDateChange}
      />
      <OrderItemList
        areOrderItems
        isUpdating={isUpdating}
        items={order.items}
        handleOrderItemValueChange={handleOrderItemValueChange}
        handleDeleteItem={handleDeleteItem}
        errors={errors}
        grades={grades}
      />
      <OrderItemList
        areOrderItems={false}
        isUpdating={false}
        items={itemList.items}
        itemAmounts={itemAmounts}
        itemPresentations={itemPresentations}
        itemGrades={itemGrades}
        handleListItemValueChange={handleListItemValueChange}
        handleAddItem={handleAddItem}
        errors={errors}
        grades={grades}
      />
      {itemList.pages > 1 &&
        <ReactPaginate
          pageCount={itemList.pages}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          previousLabel="<"
          nextLabel=">"
          onPageChange={this.props.handleListPageChange}
          initialPage={itemListPage-1}
          disableInitialCallback={true}
          containerClassName="pagination"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          activeClassName="page-item active"
          previousClassName="paginate_button previous"
          nextClassName="paginate_button next"
          disabledClassName="page-item disabled"
          forcePage={itemListPage-1}
        />
      }
    </div>
    );
  }
}
